import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import TextTruncate from 'react-text-truncate'

import Icon from 'Pods/Shared/Icon/Icon'
import NewsCard from 'Pods/Shared/NewsCard'

function EventsCard({
  title,
  image,
  dateFrom,
  dateTo,
  address,
  description,
  slug,
  subtitle = '',
}) {
  return (
    <NewsCard
      title={title}
      url={`/events/${slug}`}
      image={image}
      cardModifier=" news-card--event-card"
    >
      <div className="event-card__content">
        {subtitle ? (
          <Fragment>
            <h2 className="heading-20 u-mt0 u-mb0">{title}</h2>
            <h3 className="heading-16 u-mt0">{subtitle}</h3>
          </Fragment>
        ) : (
          <h2 className="heading-20 u-mt0">{title}</h2>
        )}
        <p className="event-card__date">
          <Icon
            className="u-mr10"
            type={['far', 'calendar']}
            color="green"
          />
          {`${moment.utc(dateFrom).format('dddd')} |
            ${moment.utc(dateFrom).format('MMM DD, YYYY')}
           -
            ${moment.utc(dateTo).format('dddd')} |
            ${moment.utc(dateTo).format('MMM DD, YYYY')}`
          }
        </p>
        {address && (
          <p className="event-card__address">
            <Icon
              className="u-mr10"
              type={['far', 'map-marker']}
              color="green"
            />
            {address}
          </p>
        )}
        <TextTruncate
          text={description}
          truncateText="…"
          containerClassName="event-card__description"
          line={2}
        />
        <div className="event-card__more-row">
          <span className="btn btn-primary event-card__more">Book a meeting</span>
        </div>
      </div>
    </NewsCard>
  )
}

EventsCard.propTypes = {
  title: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  dateFrom: PropTypes.string.isRequired,
  dateTo: PropTypes.string.isRequired,
  address: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
}

export default EventsCard
